import { FontTheme } from '../types';

import { font } from './colors';

export const font_theme: Pick<FontTheme, 'general'> = {
  general: {
    font_family: "'Roboto', sans-serif",
    font_size_small: '12px',
    font_size_normal: '13px',
    font_size_large: '14px',
  },
};

export const font_dark_theme: FontTheme = {
  general: font_theme.general,
  color: {
    normal: font.dark.normal,
    secondary: font.dark.secondary,
    tertiary: font.dark.tertiary,
    active: font.dark.active,
    focus: font.dark.focus,
    hover: font.dark.hover,
    error: font.dark.error,
    link: font.dark.link,
    disabled: font.dark.disabled,
    dark: font.dark.dark,
    light: font.dark.light,
  },
};
